import {
  IconButton,
  LinearProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  Link
} from "@mui/material";
import React, { useState } from "react";
import BreadCrumbsHeader from "../../../components/BreadCrumbsHeader";
import { useQuery } from "@tanstack/react-query";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import CustomNoRowsOverlay from "../../../components/CustomNoRowsOverlay";
import LinkIcon from "@mui/icons-material/Link";
import AddEditLLEventModal from "../../../components/Modals/AddEditLLEventModal";
import DeleteLLEventModal from "../../../components/Modals/DeleteLLEventModal";
import UserQuery from "../../../stateQueries/User";

const LLEvents = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Query for LL Events
  const { data, isLoading } = useQuery({
    queryKey: ["llEvents"],
    queryFn: async () => {
      return await UserQuery.CSEQuery.getAllLLEvents();
    }
  });

  if (isLoading) {
    return <LinearProgress />;
  }

  return (
    <Stack spacing={3}>
      <BreadCrumbsHeader
        title="Welcome back Tiyisela Themba Makamu"
        menus={[
          { name: "Dashboard", url: "/dashboard" },
          { name: "Website Management", url: "/websiteManagement" },
          { name: "LL Events", url: "/cse/llEvents" }
        ]}
        sx={{ mb: 2 }}
      />

      <Stack direction="row" justifyContent="center" alignItems="center">
        <AddEditLLEventModal />
      </Stack>

      <TableContainer component={Paper}>
        <Table aria-label="ll events table">
          <TableHead sx={{ backgroundColor: "background.paper" }}>
            <TableRow>
              <TableCell
                align="center"
                sx={{ fontWeight: "bolder", width: 80 }}
              >
                No#
              </TableCell>
              <TableCell sx={{ fontWeight: "bolder", width: "25%" }}>
                Service Provider
              </TableCell>
              <TableCell sx={{ fontWeight: "bolder", width: "20%" }}>
                Topic
              </TableCell>
              <TableCell sx={{ fontWeight: "bolder", width: "25%" }}>
                Date and Times of Training
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                Registration Link
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.llEvents && data?.llEvents.length > 0 ? (
              (rowsPerPage > 0
                ? data?.llEvents.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : data?.llEvents
              ).map((event, index) => (
                <TableRow key={event.id}>
                  <TableCell align="center">
                    {page * rowsPerPage + index + 1}
                  </TableCell>
                  <TableCell>{event.serviceProvider}</TableCell>
                  <TableCell>{event.topic}</TableCell>
                  <TableCell>
                    <Stack spacing={0.5}>
                      {event.trainingDates?.map((training, idx) => (
                        <Typography key={idx} variant="body2">
                          {training.date} ({training.time})
                        </Typography>
                      ))}
                    </Stack>
                  </TableCell>
                  <TableCell align="center">
                    {event.registrationLink ? (
                      <Tooltip title="Open Registration Link">
                        <IconButton
                          color="primary"
                          size="small"
                          component={Link}
                          href={event.registrationLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LinkIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      "N/A"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <Stack direction="row" justifyContent="center" spacing={1}>
                      <AddEditLLEventModal event={event} />
                      <DeleteLLEventModal event={event} />
                    </Stack>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6}>
                  <CustomNoRowsOverlay description="No LL Events Available" />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          {data?.llEvents && data?.llEvents.length > 0 && (
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 50, { label: "All", value: -1 }]}
                  colSpan={6}
                  count={data?.llEvents?.length || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page"
                    },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default LLEvents;
